import axios from "axios";

export const tourOperatorService = {
    async getTourOperators(params) {
        return (await axios.get('/companies/?company_type=operator' , { params } )).data
    },
}

